// import { wsApiGateway } from './urls';

import { createContext } from "react";

let wsApiGateway = process.env.REACT_APP_WS_API_GATEWAY_BASE_URL
const socket = new WebSocket(wsApiGateway);

export const SocketContext = createContext(wsApiGateway);

interface ISocketProvider {
  children: Children;
}

export const SocketProvider = (props: ISocketProvider) => (
  <SocketContext.Provider value={socket}>{props.children}</SocketContext.Provider>
);

export default socket;
